import { type IProductsSequenceTableProduct } from './ProductsSequenceTable.types';

export const DEFAULT_MAX_PRODUCTS = 10;

export const resolveProductId = (
  product: IProductsSequenceTableProduct
): string | undefined => {
  if (product?.productId !== undefined && product?.productId !== null) {
    return String(product.productId);
  }
  const nested = product?.product;
  if (
    nested !== undefined &&
    typeof nested !== 'string' &&
    nested.productId !== undefined &&
    nested.productId !== null
  ) {
    return String(nested.productId);
  }
  return undefined;
};
